import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;

`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button, a{
    background-color: transparent;
    border: none;
    cursor: pointer;
    height: 16px;
  }

`;